import React from "react";
import PageContainer from "../../../../hoc/PageContainer";
import "./AdoptASchool.css";

import { Image } from 'semantic-ui-react';
import IMG1 from "../../img/1920-service-2/1920-service-2-1-min.jpg";
import IMG2 from "../../img/1920-service-2/1920-service-2-2-min.jpg";
import IMG3 from "../../img/1920-service-2/1920-service-2-3-min.jpg";
import IMG4 from "../../img/1920-service-2/1920-service-2-4-min.jpg";
import IMG5 from "../../img/1920-service-2/1920-service-2-5-min.jpg";

const AdoptASchool = () => (
  <PageContainer page="ourServices">
    <h1 className="AboutUsTitle">
      Rotary Club of Central - Rotary District 3450 Adopt-A-School Service
      Project
    </h1>
    <br />
    <div className="AboutUsImage">
      <Image className="AboutUsImage" src={IMG2} />
    </div>
    <div className="AboutUsText">
      <p>
        Rotary Club of Central has been supportive to Rotary District 3450
        Adopt-A-School service project. Collaboration is established between
        Rotary Club of Central and its Adopt-A-School of Tuen Mun Catholic
        Secondary School for more than seven years. In RY 2019-2020, a career
        workshop was organised at Tuen Mun Catholic Secondary School to share
        with the secondary school students various facets of professional life
        which the members of Rotary Club of Central were engaged in. A mock
        interview session was arranged for Form 4 to Form 6 students to polish
        their communication and group discussion skills prior to the
        pre-university interviews and assessments. This service project achieved
        the focus of Education and Literacy out of Rotary’s six areas of focus.
        The objectives were to demonstrate the caring of younger generation in
        neighbourhood community and to promote the importance of tertiary
        education.
      </p>
    </div>
    <div className="AboutUsImage">
      <Image className="AboutUsImage" src={IMG1} />
    </div>
    <br /><br />
    <div className="AboutUsImage">
      <Image className="AboutUsImage" src={IMG3} />
    </div>
    <br /><br />
    <div className="AboutUsImage">
      <Image className="AboutUsImage" src={IMG4} />
    </div>
    <br /><br />
    <div className="AboutUsImage">
      <Image className="AboutUsImage" src={IMG5} />
    </div>
  </PageContainer>
);

export default AdoptASchool;
